import { Button, styled } from '@mui/material';

const StyledButton = styled(Button)(({ theme }) => ({
  color: theme.palette.text.secondary,
  marginInline: theme.spacing(2),
  '&:hover': {
    backgroundColor: 'transparent!important',
  },
  fontWeight: 400,
}));

export default StyledButton;
